import css from 'styled-jsx/css';

import { rgba } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentsTable {
    position: relative;
    display: flex;
    flex: auto 1;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    border-collapse: collapse;

    /* Block flow: the email row and the tag row stack, the tag always keeps its own line */
    .PaymentsTable__EmailCell {
      display: block;
      min-width: 0;
      max-width: 100%;

      /* The email column rule underlines every span via :after; the cell wrapper must not draw it */
      &:after {
        content: none !important;
      }
    }

    .PaymentsTable__EmailWrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      min-width: 0;
      max-width: 100%;

      /* The email column rule underlines every span via :after; the wrapper must not draw it */
      &:after {
        content: none !important;
      }
    }

    .PaymentsTable__EmailText {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
      max-width: 100%;
    }

    .PaymentsTable__BonusAbuserTag {
      display: inline-block;
      /* Same top gap as WithdrawApprovalListTable: keeps the chip off the email underline */
      margin-top: 8px;
      padding: 2px 8px;
      border: 1px solid #ef9a9a;
      border-radius: 4px;
      background-color: #fdecea;
      color: #c62828;
      font-size: 12px;
      line-height: 16px;
      white-space: nowrap;

      /* Same as the wrapper: no inherited :after underline on the tag */
      &:after {
        content: none !important;
      }
    }

    /* Let the email link row wrap so the tag never overlaps or gets clipped by the column edge */
    .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:nth-child(2) .RowLink {
      flex-wrap: wrap;
      gap: 4px;
    }

    /* When the tag sits directly in the link row, push it onto its own line at fit-content width */
    .RowLink > .PaymentsTable__BonusAbuserTag {
      flex-basis: 100%;
      max-width: fit-content;
    }

    @include respond-to(sm) {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch !important;
    }

    .ReactTable {
      min-width: 100% !important;
      width: 100% !important;

      .rt-thead {
        display: flex !important;
        flex: 1 1 auto !important;
        min-width: max-content !important;
        width: 100% !important;
        max-width: 100% !important;

        @include respond-to(sm) {
          min-width: 800px !important;
          width: 100% !important;
        }

        .rt-tr {
          .rt-th {
            &:first-child {
              flex: 80 0 auto !important;
              width: 80px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-child(2) {
              flex: 180 0 auto !important;
              width: 180px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-child(3) {
              flex: 80 0 auto !important;
              width: 80px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-child(4) {
              width: 140px !important;
              flex: 140 0 auto !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-child(5) {
              flex: 90 0 auto !important;
              width: 90px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-child(6) {
              flex: 90 0 auto !important;
              width: 140px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-last-child(3) {
              flex: 120 0 auto !important;
              width: 120px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
            &:nth-last-child(2) {
              flex: 200 0 auto !important;
              width: 200px !important;
              @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: auto !important;
              }
            }
          }
        }
      }
      .rt-tbody {
        display: flex !important;
        flex: 1 1 auto !important;
        min-width: max-content !important;
        width: 100% !important;
        max-width: 100% !important;

        @include respond-to(sm) {
          min-width: 800px !important;
          width: 100% !important;
        }

        .rt-tr-group {
          display: flex !important;
          flex-direction: column !important;
          width: 100% !important;
          min-width: max-content !important;
          .rt-tr {
            .rt-td {
              span {
                font-size: rem(14px);
              }
              &:first-child {
                flex: 80 0 auto !important;
                width: 80px !important;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                  flex: auto !important;
                }
              }
              &:nth-child(2) {
                flex: 180 0 auto !important;
                width: 180px !important;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                  flex: auto !important;
                }
                span {
                  font-size: rem(14px);
                  position: relative;
                  &:hover {
                    &:after {
                      width: 0;
                    }
                  }
                  &:after {
                    content: '';
                    width: 100%;
                    height: 1px;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.1);
                  }
                }
              }
              &:nth-child(3) {
                flex: 80 0 auto !important;
                width: 80px !important;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                  flex: auto !important;
                }
              }
              &:nth-child(4) {
                padding-right: 10px;
                flex: 140 0 auto !important;
                width: 140px !important;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                  flex: auto !important;
                }
                span {
                  font-size: rem(14px);
                  overflow: hidden;
                  text-overflow: clip;
                  width: 100%;
                  &:after {
                    top: 47%;
                  }
                }
              }
              &:nth-child(5) {
                flex: 90 0 auto !important;
                width: 90px !important;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                  flex: auto !important;
                }
                span {
                  font-size: rem(14px);
                }
              }
              &:nth-child(6) {
                flex: 90 0 auto !important;
                width: 140px !important;
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                  flex: auto !important;
                }
                span {
                  font-size: rem(14px);
                }
              }
              &:nth-last-child(3) {
                flex: 120 0 auto !important;
                width: 120px !important;
              }
              &:nth-last-child(2) {
                flex: 200 0 auto !important;
                width: 200px !important;
              }
              &:last-child {
                flex: 70 0 auto;
                width: 100px;
              }
            }
          }
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .PaymentsTable {    
      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        
        @media (max-width: 768px) {
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
        }
      }
      
      &__export-buttons {
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        width: auto;
        margin-left: auto;
        
        &--select {
          display: flex;
          align-items: center;
          min-width: 150px;
          max-width: 200px;
          
          .BaseSelectField {
            width: 100%;
            margin-bottom: 0 !important;
            
            .Select__control {
              padding: rem(9px 20px) !important;
              min-height: auto !important;
              height: auto !important;
              border-color: ${colors.primary.hex} !important;
              &::after {
                border-color: ${colors.primary.hex};
              }
            }

            &__label {
              color: ${colors.primary.hex};
            }
          }
        }
      }
      
      &__buttons__metadata {
        display: inline-flex;
        align-items: center;
        width: auto;
        min-width: 300px;
        max-width: 400px;

        .BaseSelectField {
          width: 100%;

          .Select__control {
            border-color: ${colors.primary.hex} !important;
            &::after {
              border-color: ${colors.primary.hex};
            }
          }

          &__label {
            color: ${colors.primary.hex};
          }
        }
      }

      .ReactTable {
        .rt-tbody {
          .rt-tr-group {
            .rt-tr {
              .rt-td {
                &:nth-child(1) {
                  a {
                    span {
                      color: ${colors.black.hex};
                    }
                  }
                }

                &:nth-child(2) {
                  span {
                    color: ${colors.secondary.hex};
                    &:after {
                      background: ${rgba([colors.secondary.rgb, 0.6])};
                    }

                    /* This column rule outranks the chip's static rule by specificity,
                       so the red tag color must be re-asserted here */
                    &.PaymentsTable__BonusAbuserTag {
                      color: #c62828;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    
    /* Force consistent padding for headers and cells */
    :global(.ReactTable .rt-th),
    :global(.ReactTable .rt-td) {
      padding: 5px !important;
      text-align: left !important;
    }
    
    /* Ensure consistent text alignment */
    :global(.ReactTable .rt-th span) {
      text-transform: uppercase !important;
    }
  `;
};

export { staticStyles, getDynamicStyles };
